import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../interfaces";
import {
  ADD_SUPPLICATION,
  AddSupplicationAction,
  DELETE_SUPPLICATION,
  DeleteSupplicationAction,
  GET_SUPPLICATION,
  GET_SUPPLICATIONS,
  GetSupplicationAction,
  GetSupplicationsAction,
  UPDATE_SUPPLICATION,
  UpdateSupplicationAction,
} from "./actionTypes";
import {
  addSupplicationError,
  addSupplicationSuccess,
  deleteSupplicationError,
  deleteSupplicationSuccess,
  getSupplicationError,
  getSupplicationSuccess,
  getSupplicationsError,
  getSupplicationsSuccess,
  updateSupplicationError,
  updateSupplicationSuccess,
} from "./actions";
import {
  addSupplication,
  deleteSupplication,
  getSupplication,
  getSupplications,
  updateSupplication,
} from "../../helpers/backend_helper";

function* getSupplicationsSaga({
  payload: { request, history },
}: GetSupplicationsAction) {
  try {
    const response: ResponseGenerator = yield call(
      getSupplications,
      request as PaginateQuery
    );
    yield put(getSupplicationsSuccess(response.data));
  } catch (error) {
    yield put(getSupplicationsError(error));
  }
}

function* getSupplicationSaga({
  payload: { id, history },
}: GetSupplicationAction) {
  try {
    const response: ResponseGenerator = yield call(getSupplication, id);
    yield put(getSupplicationSuccess(response.data));
  } catch (error) {
    yield put(getSupplicationError(error));
  }
}

function* addSupplicationSaga({
  payload: { request, history },
}: AddSupplicationAction) {
  try {
    yield call(addSupplication, request);
    yield put(addSupplicationSuccess());
  } catch (error) {
    yield put(addSupplicationError(error));
  }
}

function* updateSupplicationSaga({
  payload: { id, request, history },
}: UpdateSupplicationAction) {
  try {
    yield call(updateSupplication, id, request);
    yield put(updateSupplicationSuccess());
  } catch (error) {
    yield put(updateSupplicationError(error));
  }
}

function* deleteSupplicationSaga({
  payload: { id, history },
}: DeleteSupplicationAction) {
  try {
    yield call(deleteSupplication, id);
    yield put(deleteSupplicationSuccess());
  } catch (error) {
    yield put(deleteSupplicationError(error));
  }
}

function* SupplicationSaga() {
  yield takeEvery(GET_SUPPLICATIONS, getSupplicationsSaga);
  yield takeEvery(GET_SUPPLICATION, getSupplicationSaga);
  yield takeEvery(ADD_SUPPLICATION, addSupplicationSaga);
  yield takeEvery(UPDATE_SUPPLICATION, updateSupplicationSaga);
  yield takeEvery(DELETE_SUPPLICATION, deleteSupplicationSaga);
}

export default SupplicationSaga;
